import { render } from "./delivery-info.vue?vue&type=template&id=68df5172"
import script from "./delivery-info.vue?vue&type=script&lang=js"
export * from "./delivery-info.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__